import script from "./stickySummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./stickySummary.vue?vue&type=script&setup=true&lang=ts"

import "./stickySummary.vue?vue&type=style&index=0&id=57b35faa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57b35faa"]])

export default __exports__